import Alpine from 'alpinejs';


Alpine.data('mobileNavigation', () => ({
  level: 0,
  get style() {
    return `--left: -${this.level * 100}%`;
  },
  events: {
    ['x-intersect:leave.full']() {
      this.level = 0;
    },
    ['x-on:keydown.escape.window.prevent']() {
      this.goBackOrClose();
    }
  },
  open() {
    this.$root.showModal();
  },
  close() {
    this.$root.close();
  },
  goBackOrClose() {
    if (this.level === 0) {
      this.close();
    } else {
      this.decrementLevel();
    }
  },
  incrementLevel(e) {
    e.target.closest('li').querySelector('ul').classList.remove('hidden');
    this.level++;
  },
  decrementLevel(e) {
    this.level = Math.max(0, this.level - 1);

    Shopify.helpers.wait(300).then(() => {
      e.target.closest('ul').classList.add('hidden');
    });
  },
}));